exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stage-two {\n  min-width: 750px; }\n  .stage-two .next {\n    cursor: pointer;\n    float: right;\n    margin-top: 20px;\n    margin-bottom: 25px;\n    margin-left: 10px;\n    user-select: none;\n    width: 150px; }\n  .stage-two .back {\n    cursor: pointer;\n    float: right;\n    margin-top: 20px;\n    margin-bottom: 25px;\n    user-select: none;\n    width: 150px; }\n  .stage-two .ant-form-item {\n    display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/ReportForm/components/StageTwo/style.scss
// module id = 1016
// module chunks = 0